import React from 'react'
import styled from 'styled-components'
import {useTranslation} from 'i18n'
import {useDidMount} from 'utils'
import {Button, Input, Modal, Paragraph} from 'common/components'
import convertUnit from 'lib/unit'
import {TransactionWithdrawValidationProps} from './TransactionWithdrawValidationProps '

const StyledModal = styled(Modal)`
  width: ${convertUnit(275)};
  padding: ${convertUnit(25)};
`

const StyledParagraph = styled(Paragraph)`
  text-align: center;
`

const StyledButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: ${convertUnit(25)};
`

const StyledButton = styled(Button)`
  width: ${convertUnit(125)};
`

export default function TransactionWithdrawValidation({
  disabledButton,
  isLoading,
  onClickCancel,
  onClickConfirm,
  withdrawForm,
}: TransactionWithdrawValidationProps) {
  const {translate} = useTranslation()

  const {handleSubmit, register, errors} = withdrawForm

  useDidMount(() => {
    register('password')
  })

  return (
    <StyledModal visible>
      <StyledParagraph fontSize="l" fontWeight="bold">
        {translate('giftShop:withdrawEnterPassword')}
      </StyledParagraph>

      <Input
        type="password"
        name="password"
        form={withdrawForm}
        placeholder={translate('giftShop:withdrawEnterPasswordPlaceholder')}
        containerStyle={{
          marginTop: convertUnit(18),
        }}
        rightIcon="visibility"
      />

      <StyledButtonContainer>
        <StyledButton
          label="Cancel"
          fontSize="m"
          fontWeight="medium"
          onClick={onClickCancel}
          backgroundColor="white_3"
          color="primary_5"
        />
        <StyledButton
          label="Confirm"
          fontSize="m"
          fontWeight="medium"
          isLoading={isLoading}
          disabled={errors.password !== undefined || disabledButton}
          disableColor="gray_1"
          color={errors.password !== undefined ? 'gray_3' : 'white_1'}
          onClick={handleSubmit(onClickConfirm)}
        />
      </StyledButtonContainer>
    </StyledModal>
  )
}
